<template lang="pug">
    .page
        //- Add Modal
        a-modal(v-model="addVisible"
            title="添加产品 PnL 权限"
            @ok="handleAddOk"
            ok-text="添加"
            cancel-text="取消")
            a-form-model(:model="form" :label-col="{ span: 5 }" :wrapper-col="{ span: 18 }")
                a-form-model-item(label="产品名称")
                    a-input(v-model="form.product" placeholder="输入产品名称")
                a-form-model-item(label="授权用户")
                    a-select(v-model="form.userId"
                        placeholder="选择用户"
                        show-search
                        :filter-option="filterOption")
                        a-select-option(v-for="user in activeUsers" :key="user._id" :value="user._id") {{ user.name }}
                a-form-model-item(label="策略名")
                    a-input(v-model="form.strategyName" placeholder="输入策略名（可选）")

        //- Edit Drawer
        a-drawer(:visible="editVisible"
            title="编辑策略名"
            width="500"
            @close="editVisible=false")
            a-form-model(:model="editForm" :label-col="{ span: 5 }" :wrapper-col="{ span: 18 }")
                a-form-model-item(label="产品名称")
                    a-input(:value="editForm.product" disabled)
                a-form-model-item(label="授权用户")
                    a-input(:value="editForm.userName" disabled)
                a-form-model-item(label="策略名")
                    a-input(v-model="editForm.strategyName" placeholder="输入策略名（可选）")
            a-button(type="primary" style="margin-top:20px" @click="submitEdit") 保存修改

        .ctl-bar
            a-button(type="primary"
                @click="handleCreate"
                style="margin-right:20px")
                a-icon(type="plus")
                span 添加权限

            a-button(type="primary"
                style="margin-right:20px"
                @click="getData")
                a-icon(type="redo")
                span 刷新

            a-input-search(placeholder="搜索产品、用户或策略名"
                style="width: 240px"
                v-model="search")

        a-table(:columns="columns"
            size="small"
            :dataSource="filteredItems"
            :pagination="{ pageSize: 50 }"
            rowKey="_id")
            template(slot="user" slot-scope="text")
                span {{ text ? text.name : '-' }}
            template(slot="createdAt" slot-scope="text")
                span {{ text ? new Date(text).toLocaleString() : '-' }}
            template(slot="action" slot-scope="record")
                a(@click="handleEdit(record)" style="margin-right: 12px;")
                    a-icon(type="edit")
                    span 编辑
                a-divider(type="vertical")
                a-popconfirm(title="确认移除该用户的授权吗？"
                    ok-text="确认"
                    cancel-text="取消"
                    @confirm="submitDelete(record)")
                    a(style="color: red;")
                        a-icon(type="delete")
                        span 移除
</template>

<script>
export default {
    data() {
        return {
            addVisible: false,
            editVisible: false,
            search: '',
            form: {
                product: '',
                userId: '',
                strategyName: ''
            },
            editForm: {
                product: '',
                userId: '',
                userName: '',
                strategyName: ''
            },
            items: [],
            users: [],
            columns: [
                {
                    title: '产品',
                    dataIndex: 'product',
                    sorter: (a, b) => (a.product || '').localeCompare(b.product || ''),
                },
                {
                    title: '用户',
                    dataIndex: 'userId',
                    scopedSlots: { customRender: 'user' },
                    sorter: (a, b) => {
                        const an = a.userId ? a.userId.name : '';
                        const bn = b.userId ? b.userId.name : '';
                        return an.localeCompare(bn);
                    },
                },
                {
                    title: '策略名',
                    dataIndex: 'strategyName',
                    sorter: (a, b) => (a.strategyName || '').localeCompare(b.strategyName || ''),
                },
                {
                    title: '授权时间',
                    dataIndex: 'createdAt',
                    scopedSlots: { customRender: 'createdAt' },
                    sorter: (a, b) => new Date(a.createdAt || 0) - new Date(b.createdAt || 0),
                },
                {
                    title: '操作',
                    width: 160,
                    scopedSlots: { customRender: 'action' },
                }
            ]
        };
    },
    computed: {
        activeUsers() {
            return this.users.filter(u => u.isActive);
        },
        filteredItems() {
            const kw = this.search.trim().toLowerCase();
            if (!kw) return this.items;
            return this.items.filter(i => {
                const product = (i.product || '').toLowerCase();
                const userName = i.userId ? (i.userId.name || '').toLowerCase() : '';
                const strategyName = (i.strategyName || '').toLowerCase();
                return product.includes(kw) || userName.includes(kw) || strategyName.includes(kw);
            });
        }
    },
    mounted() {
        this.getUsers();
        this.getData();
    },
    methods: {
        filterOption(input, option) {
            return option.componentOptions.children[0].text.toLowerCase().includes(input.toLowerCase());
        },
        handleCreate() {
            this.form = { product: '', userId: '', strategyName: '' };
            this.addVisible = true;
        },
        handleEdit(record) {
            this.editForm = {
                product: record.product || '',
                userId: record.userId ? record.userId._id : '',
                userName: record.userId ? record.userId.name : '',
                strategyName: record.strategyName || ''
            };
            this.editVisible = true;
        },
        submitEdit() {
            if (!this.editForm.product || !this.editForm.userId) {
                this.$message.error('参数错误');
                return;
            }
            this.$api.request('POST', `productPerms/${encodeURIComponent(this.editForm.product)}/user`, {
                userId: this.editForm.userId,
                strategyName: this.editForm.strategyName
            })
            .then(() => {
                this.$message.success('修改成功');
                this.editVisible = false;
                this.getData();
            });
        },
        handleAddOk() {
            if (!this.form.product || !this.form.userId) {
                this.$message.error('产品名称和用户不能为空');
                return;
            }
            this.$api.request('POST', `productPerms/${encodeURIComponent(this.form.product)}/user`, {
                userId: this.form.userId,
                strategyName: this.form.strategyName
            })
            .then(() => {
                this.$message.success('添加成功');
                this.addVisible = false;
                this.getData();
            });
        },
        submitDelete(record) {
            const userId = record.userId ? record.userId._id : '';
            this.$api.request('DELETE', `productPerms/${encodeURIComponent(record.product)}/user/${userId}`)
            .then(() => {
                this.$message.success('已移除授权');
                this.getData();
            });
        },
        getData() {
            this.$api.request('GET', 'productPerms')
            .then(res => {
                this.items = res.data;
            });
        },
        getUsers() {
            this.$api.request('GET', 'users')
            .then(res => {
                this.users = res.data;
            });
        }
    }
};
</script>

<style lang="less" scoped>
.ctl-bar {
    margin-bottom: 20px;
}
</style>
